//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"AllowReferenceCurves",1,0],[0,"AllowSelfIntersection",1,0],[0,"ChainBetween",1,0],[0,"InterPartCollector",1,0],[0,"InterPartSection",1,0],[0,"InterPartSelectionType",1,0],[0,"LaminarEdgesOnly",1,0],[0,"MixedComponentCollector",1,0],[0,"MixedComponentSection",1,0],[0,"NoCMODCollector",1,0],[0,"NonFeatureModeOfCollector",1,0],[0,"NonFeatureModeOfSection",1,0],[0,"RetainPartLoadStatusForCollector",1,0],[0,"RetainPartLoadStatusForSection",1,0]],[],[]];
SPLM.SIAutotestPreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIAutotestPreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIAutotestPreferencesBuilder.InterPartSelectionTypes = Object.freeze({
    "SimpleSelection" : "SimpleSelection", "NonAssociative" : "NonAssociative", "AssociativeAndNonAssociative" : "AssociativeAndNonAssociative", "Associative" : "Associative"});

export default SPLM;